import axios from 'axios';

export const getSerieRecordingList = url =>
  axios
    .get(url)
    .then(response => response?.data)
    .catch(response => response?.data);
